import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import dataLayer from '../../utils/data-layer';
import Manipulator from '../../utils/dom/manipulator';

class CourtCourseSearchResults {
    constructor() {
        this.wrapper = SelectorEngine.findOne('.p-lta-court-course-search-results');

        if (!this.wrapper) {
            return;
        }

        this.init();
    }

    init() {
        this.courtCourseBtns = SelectorEngine.find('.p-court-course-search-result-card', this.wrapper);
		if (!this.courtCourseBtns.length) {
			return;
		}

		this.courtCourseBtns.forEach((btn) => {	
			EventHandler.on(btn, 'click', () => this.trackClick(btn));
		});
    }

	trackClick(btn) {

		const bookingType = Manipulator.getDataAttribute(btn, 'type-of-booking');
		const stepComplete = Manipulator.getDataAttribute(btn, 'step-complete');
		try {
			dataLayer.push({
				event: bookingType,
				step_Completed: stepComplete
			});
		} catch (error) {
			console.error(error.message);
		}
		
	}
}

const courtCourseSearchResult = new CourtCourseSearchResults();

export default courtCourseSearchResult;
